/* createBackgroundColor.ts */

/* Constants */
import { Paths } from "src/shared/constants/common/Paths";

/* Interfaces */
interface ScssProps {
  position?: "absolute" | "relative" | "static";
  top?: string;
  left?: string;
  width?: string;
  backgroundColor: string;
  color: string;
  zIndex?: number;
}

export const createScssProps = (
  path: string,
  scrollPosition: number
): ScssProps => {
  const transparent = scrollPosition < 175;

  switch (path) {
    case Paths.IMPRINT:
      return {
        position: "absolute",
        top: "0",
        left: "0",
        width: "100%",
        backgroundColor: transparent
          ? "transparent"
          : "var(--ion-gradient-light)",
        color: transparent
          ? "#ffffff"
          : "var(--ion-color-text-primary)",
        zIndex: 1000,
      };
    default:
      return {
        position: "static",
        backgroundColor: "var(--ion-gradient-light)",
        color: "var(--ion-color-text-primary)",
      };
  }
};
